import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Gift, Save, RefreshCw } from "lucide-react";

export default function ShareRewardsPanel() {
  const [d, setD] = useState(null);
  const [coins, setCoins] = useState("");
  const load = () => api.get("/admin/share-rewards").then(({ data }) => { setD(data); setCoins(String(data.reward_blc)); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { const { data } = await api.put("/admin/share-rewards", { coins: Number(coins) }); toast.success(`Share reward set to ${data.reward_blc} BLC`); load(); }
    catch { toast.error("Could not save"); }
  };
  return (
    <div className="mt-6 border border-pb-border bg-pb-surface p-5" data-testid="share-rewards-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-1">
        <div className="flex items-center gap-2"><Gift className="w-4 h-4 text-amber-400" /><span className="font-display font-bold uppercase">Share Rewards — Members Earn BLC</span></div>
        <button data-testid="share-rewards-refresh" onClick={load} className="w-7 h-7 flex items-center justify-center border border-pb-border hover:border-pb-red"><RefreshCw className="w-3.5 h-3.5" /></button>
      </div>
      <p className="text-xs text-zinc-500 mb-4">Every member's Share button carries their referral tag. When a friend buys a Pro Shop item through that link (card or coin, within 30 days), the member is paid bonus BLC from the Red Vault and notified. Self-purchases never pay out; one reward per order.</p>
      <div className="flex flex-wrap items-end gap-3 mb-4">
        <div>
          <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-1">Reward per order (BLC)</label>
          <input data-testid="share-reward-input" type="number" min="0" max="500" step="0.5" value={coins} onChange={(e) => setCoins(e.target.value)}
            className="w-32 bg-pb-elevated border border-pb-border px-3 py-2 text-white font-mono text-sm focus:outline-none focus:border-amber-400" />
        </div>
        <button data-testid="share-reward-save" onClick={save} className="flex items-center gap-1.5 bg-amber-400 text-black px-4 py-2 text-xs font-black uppercase tracking-widest hover:bg-amber-300"><Save className="w-3.5 h-3.5" /> Save</button>
        {d && (
          <div className="ml-auto flex gap-6 text-[10px] uppercase tracking-widest text-zinc-400" data-testid="share-rewards-stats">
            <span><b className="text-white text-base font-display">{d.orders}</b> referred orders</span>
            <span><b className="text-amber-300 text-base font-display">{d.total_paid}</b> BLC paid out</span>
          </div>
        )}
      </div>
      {d && (d.top.length > 0 || d.recent.length > 0) && (
        <div className="grid md:grid-cols-2 gap-4 text-xs">
          <div>
            <div className="text-[9px] uppercase tracking-[0.25em] text-zinc-500 mb-1.5">Top sharers</div>
            {d.top.map((t, i) => (
              <div key={i} className="flex justify-between border-b border-pb-border/40 py-1" data-testid={`share-top-${i}`}><span className="text-white">{t.name}</span><span className="text-zinc-400">{t.orders} order{t.orders === 1 ? "" : "s"} · <span className="text-amber-300">{t.coins} BLC</span></span></div>
            ))}
          </div>
          <div>
            <div className="text-[9px] uppercase tracking-[0.25em] text-zinc-500 mb-1.5">Recent payouts</div>
            {d.recent.map((r) => (
              <div key={r.id} className="border-b border-pb-border/40 py-1" data-testid={`share-recent-${r.id}`}>
                <span className="text-white">{r.referrer}</span> <span className="text-amber-300">+{r.coins}</span> <span className="text-zinc-500">← {r.buyer} bought {r.items} ({r.paid_with})</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {d && d.orders === 0 && <div className="text-xs text-zinc-600" data-testid="share-rewards-empty">No referred purchases yet — the first one will show here.</div>}
    </div>
  );
}
